import { Text } from '@shared/components/Text';
import { View, ViewProps } from '@shared/components/View';
import styles from './MenuSection.module.css';

/**
 * MenuSection
 *
 * A section of a menu. Use this to render arbitrary content within a menu, with
 * the same padding as MenuItem. (Don't put MenuItems in a MenuSection.)
 */

interface MenuSectionProps extends ViewProps {
  title?: string;
}

export function MenuSection({ children, title, className, ...rest }: MenuSectionProps) {
  return (
    <View className={[styles.menuSection, className]} {...rest}>
      {title && (
        <Text size="overline" weight="semibold" className={styles.menuSectionTitle}>
          {title}
        </Text>
      )}
      {children}
    </View>
  );
}
